import React, { FC } from 'react'
import { BasketType } from 'types/basket'
import { OrderTime, OrderType } from 'types/checkout'
import { UserType } from 'types/user'
import { DeliveryOrderCard, OrderCard } from 'components/Card'
import { Spacer } from 'components/Utility'
import { StoreType } from 'types/store'
import { StoreShippingType } from 'types/storeShipping'

type Props = {
  baskets: BasketType[]
  orders: OrderType[]
  orderTimes: OrderTime[]
  storeShippings: StoreShippingType[]
  stores: StoreType[]
  users: UserType[]
}

const SearchOrderCardList: FC<Props> = (props) => {
  const { baskets, orders, orderTimes, storeShippings, stores, users } = props

  return (
    <div>
      {baskets
        .sort((a, b) => {
          // 同日、同ユーザー、同店舗の注文で受取番号の並び替えを行う（デフォルトは注文日時の降順）
          const basketA = orders
            .filter(
              (order) =>
                order.user_id === a.user_id &&
                order.items.some((item) => item.store_ref.id === a.store_ref.id) &&
                order.date === a.date
            )
            .reduce(
              (prev, order) =>
                Math.max(
                  prev,
                  order.checkout_at ? order.checkout_at.toDate().getTime() : order.updated_at.toDate().getTime()
                ),
              0
            )
          const basketB = orders
            .filter(
              (order) =>
                order.user_id === b.user_id &&
                order.items.some((item) => item.store_ref.id === b.store_ref.id) &&
                order.date === b.date
            )
            .reduce(
              (prev, order) =>
                Math.max(
                  prev,
                  order.checkout_at ? order.checkout_at.toDate().getTime() : order.updated_at.toDate().getTime()
                ),
              0
            )
          return basketA > basketB ? -1 : 1
        })
        .map((basket) => {
          const _orders = orders.filter((order) => {
            // 1受取番号につき同日、同ユーザー、同店舗の注文をまとめる
            return (
              order.user_id === basket.user_id &&
              order.items.some((item) => item.store_ref.id === basket.store_ref.id) &&
              order.date === basket.date
            )
          })
          if (_orders.length === 0) return
          const orderTime = orderTimes.find((orderTime) => orderTime.user_id === basket.user_id)
          if (!orderTime) return
          const store = stores.find((store) => store.store_id === _orders[0].items[0]?.store_ref.id)
          // 生産店舗名
          const manufacturerNames = _orders
            .map((order) =>
              order.items
                .reduce((prev: string[], item) => {
                  if (prev.includes(item.manufacturer_name)) {
                    return prev
                  } else {
                    return [...prev, item.manufacturer_name]
                  }
                }, [])
                .join('・')
            )
            .join('・')
          const user = users.find((user) => user.user_id === basket.user_id) ?? undefined
          return (
            <React.Fragment key={basket.basket_number}>
              <OrderCard
                basketNumber={basket.basket_number}
                isSearch={true}
                manufacturerNames={manufacturerNames}
                orders={_orders}
                orderTime={orderTime}
                store={store}
                user={user}
                date={_orders[0].date}
              />
              <Spacer size={12} />
            </React.Fragment>
          )
        })}
      {storeShippings
        .sort((a, b) => {
          // 同日、同ユーザー、同店舗の注文で受取番号の並び替えを行う（デフォルトは注文日時の降順）
          const storeShippingA = orders
            .filter(
              (order) =>
                order.user_id === a.user_id &&
                order.items.some((item) => item.store_ref.id === a.store_ref.id) &&
                order.date === a.scheduled_delivery_date
            )
            .reduce(
              (prev, order) =>
                Math.max(
                  prev,
                  order.checkout_at ? order.checkout_at.toDate().getTime() : order.updated_at.toDate().getTime()
                ),
              0
            )
          const storeShippingB = orders
            .filter(
              (order) =>
                order.user_id === b.user_id &&
                order.items.some((item) => item.store_ref.id === b.store_ref.id) &&
                order.date === b.scheduled_delivery_date
            )
            .reduce(
              (prev, order) =>
                Math.max(
                  prev,
                  order.checkout_at ? order.checkout_at.toDate().getTime() : order.updated_at.toDate().getTime()
                ),
              0
            )
          return storeShippingA > storeShippingB ? -1 : 1
        })
        .map((storeShipping) => {
          const _order = orders.find((order) => {
            // 1受取番号につき同日、同ユーザー、同店舗の注文をまとめる
            return (
              order.user_id === storeShipping.user_id &&
              order.items.some((item) => item.store_ref.id === storeShipping.store_ref.id) &&
              order.date === storeShipping.scheduled_delivery_date
            )
          })
          if (!_order) return
          const orderTime = orderTimes.find((orderTime) => orderTime.user_id === storeShipping.user_id)
          if (!orderTime) return
          const store = stores.find((store) => store.store_id === _order.items[0]?.store_ref.id)
          // 生産店舗名
          const manufacturerNames = _order.items
            .reduce((prev: string[], item) => {
              if (prev.includes(item.manufacturer_name)) {
                return prev
              } else {
                return [...prev, item.manufacturer_name]
              }
            }, [])
            .join('・')
          const user = users.find((user) => user.user_id === storeShipping.user_id) ?? undefined
          return (
            <React.Fragment key={storeShipping.shipping_number}>
              <DeliveryOrderCard
                isSearch={true}
                manufacturerNames={manufacturerNames}
                order={_order}
                orderTime={orderTime}
                store={store}
                storeShipping={storeShipping}
                user={user}
              />
              <Spacer size={12} />
            </React.Fragment>
          )
        })}
    </div>
  )
}

export default SearchOrderCardList
